module.exports = __webpack_public_path__ + "img/Dantam Hair 19.eff42b12.jpg";